<template>
  <el-dropdown
    class="sk-p2-dropdown"
    :trigger="trigger"
    :placement="placement"
    :disabled="disabled"
    v-bind="$attrs"
    v-on="dropdownListeners"
    @command="handleCommand"
    @visible-change="handleVisibleChange"
  >
    <!-- Trigger Slot: Cho phép truyền nút tuỳ biến hoặc dùng nút mặc định -->
    <slot>
      <Phase2ActionButton
        :type="buttonType"
        :size="buttonSize"
        :disabled="disabled"
        :loading="loading"
        :style="{ minWidth: minWidth }"
      >
        <i v-if="buttonIcon" :class="buttonIcon" />
        <span>{{ label }}</span>
        <i
          :class="[arrowIcon, 'sk-p2-dropdown__arrow', { 'is-active': isVisible }]"
        />
      </Phase2ActionButton>
    </slot>

    <!-- Menu Dropdown -->
    <el-dropdown-menu slot="dropdown" :class="computedMenuClass">
      <template v-if="items && items.length">
        <template v-for="(item, index) in items">
          <el-dropdown-item
            :key="item.command || index"
            :command="item.command"
            :disabled="item.disabled"
            :divided="item.divided"
            :class="[
              item.danger ? 'is-danger' : '',
              item.customClass || ''
            ]"
          >
            <i v-if="item.icon" :class="item.icon" />
            <span>{{ item.label }}</span>
          </el-dropdown-item>
        </template>
      </template>
      <slot v-else name="dropdown" />
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Phase2ActionButton from "./Phase2ActionButton.vue";

export default {
  name: "Phase2Dropdown",
  components: {
    Phase2ActionButton,
  },
  inheritAttrs: false,
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "Tác vụ",
    },
    buttonType: {
      type: String,
      default: "primary",
    },
    buttonSize: {
      type: String,
      default: "small",
    },
    buttonIcon: {
      type: String,
      default: "",
    },
    arrowIcon: {
      type: String,
      default: "el-icon-arrow-down",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: String,
      default: "110px",
    },
    trigger: {
      type: String,
      default: "click",
    },
    placement: {
      type: String,
      default: "bottom-end",
    },
    popperClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    // These events are handled and re-emitted below. Forwarding their parent
    // listeners directly to el-dropdown would invoke the parent twice.
    dropdownListeners() {
      const listeners = Object.assign({}, this.$listeners);
      delete listeners.command;
      delete listeners['visible-change'];
      return listeners;
    },
    currentTheme() {
      return this.$store && this.$store.getters
        ? this.$store.getters["theme/currentTheme"]
        : "";
    },
    themeClass() {
      return this.currentTheme ? `theme-${this.currentTheme}` : "";
    },
    computedMenuClass() {
      return [
        "sk-p2-dropdown-menu",
        this.themeClass,
        this.popperClass,
      ].filter(Boolean).join(" ");
    },
  },
  methods: {
    handleVisibleChange(val) {
      this.isVisible = val;
      this.$emit("visible-change", val);
    },
    handleCommand(command) {
      this.$emit("command", command);
    },
  },
};
</script>
